import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '../Card';
import { Button } from '../Button';
export function FeaturedServices() {
  const services = [{
    title: 'Professional Deep Cleaning',
    price: '$225',
    description: "Experience our thorough and detailed service catered to meet your specific cleaning needs. Whether it's for your home or business, we've got you covered.",
    image: 'https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?q=80&w=1000&auto=format&fit=crop' // Clean floor/vacuum
  }, {
    title: 'Specialized Move Out Clean',
    price: '$225',
    description: 'Let us take the stress out of moving with our deep clean for your old place. Leave it spotless for the next occupants.',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=1000&auto=format&fit=crop' // Empty room / moving vibe
  }, {
    title: 'Airbnb Cleaning Solution',
    price: '$99',
    description: 'Ensure your guests have a pristine and inviting space with our top-notch cleaning services for your Airbnb property.',
    image: 'https://images.unsplash.com/photo-1618220179428-22790b461013?q=80&w=1000&auto=format&fit=crop' // Tidy guest bedroom
  }];
  return <section id="services" className="py-20 md:py-32 bg-brand-white" data-id="element-129">
      <div className="container mx-auto px-4 md:px-6" data-id="element-130">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-131">
          <h2 className="font-display font-bold text-3xl md:text-4xl lg:text-5xl text-brand-navy mb-4" data-id="element-132">
            Our Services
          </h2>
          <p className="text-lg text-brand-navy/70" data-id="element-133">
            Pick the clean that fits your needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-134">
          {services.map((service, index) => <Card key={index} className="overflow-hidden border-brand-sky/50 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full bg-brand-white" data-id="element-135">
              <div className="h-48 overflow-hidden" data-id="element-136">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-137" />
              </div>
              <CardHeader className="pb-4" data-id="element-138">
                <CardTitle className="font-display text-xl text-brand-navy leading-tight" data-id="element-139">
                  {service.title}
                </CardTitle>
                <div className="text-brand-aqua font-semibold mt-2" data-id="element-140">
                  Starting at {service.price}
                </div>
              </CardHeader>
              <CardContent className="flex-grow" data-id="element-141">
                <CardDescription className="text-brand-navy/70 text-base leading-relaxed" data-id="element-142">
                  {service.description}
                </CardDescription>
              </CardContent>
              <CardFooter className="pt-4 border-t border-brand-gray" data-id="element-143">
                <Button className="w-full bg-brand-aqua hover:bg-brand-aqua-dark text-white rounded-full h-12 font-semibold text-base" data-id="element-144">
                  Sign Up
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}